import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=0be74843"
import script from "./table-view.vue?vue&type=script&lang=js"
export * from "./table-view.vue?vue&type=script&lang=js"
import style0 from "./table-view.vue?vue&type=style&index=0&id=0be74843&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports